import {
  connectBaseApi,
  createRpcMutation,
  createRpcQuery,
  driverIncidentClient,
} from "@racoon/api";

const driverIncidentGrpc = connectBaseApi.injectEndpoints({
  endpoints: (build) => ({
    listDriverIncidents: createRpcQuery(build, driverIncidentClient, "listDriverIncidents", {
      providesTags: ["DriverIncident"],
    }),
    // A dispatcher's reason for a job, saved under JOB_INCIDENT_SAVE: the job's lists of
    // incidents pick it up as its newest, the registry's from the saved result.
    createJobIncident: createRpcMutation(build, driverIncidentClient, "createJobIncident", {
      invalidatesTags: ["DriverIncident"],
    }),
  }),
  overrideExisting: false,
});

/** The shared cache key of the report's incident save, which the registry reads too. */
export const JOB_INCIDENT_SAVE = "job-incident-save";

export const { useListDriverIncidentsQuery, useCreateJobIncidentMutation } = driverIncidentGrpc;
